import Vue from 'vue';
export function disableTransitions() {
	const div = {
		functional: true,
		render(h, context) {
			return context.children;
		}
	};
	Vue.component('transition', div);
	Vue.component('transition-group', div);
}
